module.exports = __webpack_public_path__ + "media/images/icon__point--white@3x-5c25e002f7ed055ee9c1c8f5e69d57c3.png";